<template>
	<div class="content">
		<van-tabs v-model="activeType" @click="toggleType">
			<van-tab title="爸爸"></van-tab>
			<van-tab title="妈妈"></van-tab>
			<van-tab title="奶奶"></van-tab>
			<van-tab title="李星泽"></van-tab>
		</van-tabs>
		<div class="current">已{{ loseWeight > 0 ? '减' : '增' }}{{ Math.abs(loseWeight) }}斤</div>
		<div class="input-weight">
			<van-field v-model="weight" label="记录体重" placeholder="输入体重">
			</van-field>
			斤
			<van-button plain type="primary" @click="recordWeight" :disabled="!Boolean(weight)">记录</van-button>
		</div>
		<div v-if="weightList.length > 0" class="record-content">
			<div id="myChart" ref="myChart" :style="{ width: '100%', 'min-height': '240px' }"></div>
			<div class="weight-content-record">
				<div class="weight-content-record-column">日期</div>
				<div class="weight-content-record-column">体重(斤)</div>
				<div class="weight-content-record-column">操作</div>
			</div>
			<div class="weight-content-record-box">
				<div class="weight-content-record" v-for="record in weightList" :key="record.id">
					<div class="weight-content-record-column">{{ record.time }}</div>
					<div class="weight-content-record-column">{{ record.weight }}
						<span :class="{ 'weight-content-record-down': record.change.tag === 'down' }"
							v-if="record.change">
							(<van-icon :name="record.change.tag" />
							{{ record.change.value }})
						</span>
					</div>
					<div class="weight-content-record-column">
						<van-button type="danger" size="small" @click="deleteWeightRecord(record.id)">删除</van-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	getWeightList,
	recordWeight,
	deleteWeightRecord,
} from '../util/api'
import { Dialog } from 'vant';
export default {
	name: 'loseWeightCom',
	data() {
		return {
			activeType: 0,
			weight: null,
			roleMap: {
				'mom': '妈妈',
				'dad': '爸爸',
				'grandMa': '奶奶',
				'son': '李星泽'
			},
			weightList: [],
			loseWeight: null
		}
	},
	methods: {
		toggleType(type) {
			this.activeType = type
			this.getList();
		},
		getList() {
			getWeightList({
				role: this.getRole()
			}).then((res) => {
				const data = (res.data || []).sort((a, b) => new Date(b.time) - new Date(a.time));
				this.weightList = data.map((item, index) => {
					if (index < data.length - 1) {
						const value = (data[index].weight - data[index + 1].weight).toFixed(1)
						if (!value) {
							return
						}
						item.change = {
							value,
							tag: this.getTag(value)
						}
					}
					return item
				})
				this.loseWeight = (this.weightList[this.weightList.length - 1].weight - this.weightList[0].weight).toFixed(2)
				if (this.weightList && this.weightList.length > 0) {
					this.$nextTick(() => {
						this.getChartWeightList()
					})
				}
			})
		},
		deleteWeightRecord(id) {
			Dialog.confirm({
				message: '确认删除这次记录吗'
			}).then(() => {
				deleteWeightRecord({
					id
				}).then(() => {
					this.getList()
				})
			}).catch(() => {
				// on cancel
			});
		},
		recordWeight() {
			recordWeight({
				role: this.getRole(), weight: this.weight, date: this.getDate(), time: new Date().toLocaleString()
			}).then(() => {
				this.getList()
			})
		},
		getRole() {
			switch (this.activeType) {
				case 0:
					return "dad"
				case 1:
					return "mom"
				case 2:
					return "grandMa"
				case 3:
					return "son"
			}
		},
		getDate() {
			const currentDate = new Date();
			const year = currentDate.getFullYear();
			const month = currentDate.getMonth() + 1;
			const day = currentDate.getDate();
			return `${year}-${month}-${day}`
		},
		getChartWeightList() {
			let minWeight = 0, maxWeight = 0
			const data = this.weightList || [];
			const xData = []
			const yData = []
			if (data.length > 0) {
				minWeight = data[0].weight, maxWeight = data[0].weight
				const maxLength = data.length - 1
				for (let i = maxLength; i > -1; i--) {
					const { date, weight } = data[i]
					xData.push(date)
					yData.push(weight)
					if (weight > maxWeight) {
						maxWeight = weight
					}
					if (weight < minWeight) {
						minWeight = weight
					}
				}
				maxWeight = Math.ceil(maxWeight)
				minWeight = Math.floor(minWeight)
			}
			const option = {
				xAxis: {
					type: 'category',
					data: xData
				},
				yAxis: {
					type: 'value',
					min: minWeight,
					max: maxWeight
				},
				series: [
					{
						data: yData,
						type: 'line',
						smooth: true,
						itemStyle: {
							color: '#3e4950'
						},
						lineStyle: {
							color: '#8ac4ba',
							width: 2
						}
					}
				],
				tooltip: {
					trigger: 'axis', // 触发类型，默认数据项触发，可选为：'item' | 'axis' | 'none'
					triggerOn: 'click',
					formatter: function (params) { // 使用函数来自定义提示框内容格式
						return `${params[0].axisValue}: ${params[0].value}斤`;
					}
				},
			}
			this.setChart(option);
		},
		setChart(option) {
			// 在步骤2的方法1中 通过 this.$echarts.init方法初始化echarts实例并使用 setOption 方法注册图表配置项和数据
			let myChart = this.$echarts.init(document.getElementById("myChart"));
			myChart.setOption(option);
			window.addEventListener("resize", function () {
				myChart.resize();
			});
		},
		getTag(value) {
			if (value > 0) {
				return 'back-top'
			} else if (value < 0) {
				return 'down'
			}
		}
	},
	mounted() {
		this.getList();
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
	/* Q版：柔和底色 + 贴纸卡片 */
	--q-bg0: #fff7fb;
	--q-bg1: #f2fbff;
	--q-card: rgba(255, 255, 255, 0.92);
	--q-line: rgba(15, 23, 42, 0.08);
	--q-shadow: 0 10px 24px rgba(17, 24, 39, 0.08);
	--q-shadow-sm: 0 6px 14px rgba(17, 24, 39, 0.08);
	--q-radius: 18px;
	--q-primary: #34c3ff;
	--q-primary-2: #6ee7ff;
	--q-danger: #ff5f7a;

	padding: 14px 14px 18px;
	display: flex;
	flex-direction: column;
	height: 100%;
	box-sizing: border-box;
	position: relative;
	font-family: "Comic Sans MS", "Microsoft YaHei UI", "PingFang SC", "Hiragino Sans GB", system-ui, -apple-system,
		BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
	background: radial-gradient(120% 90% at 20% 0%, var(--q-bg0) 0%, transparent 60%),
		radial-gradient(120% 90% at 90% 30%, var(--q-bg1) 0%, transparent 55%),
		#ffffff;
}

.content::before,
.content::after {
	content: "";
	position: fixed;
	z-index: -1;
	pointer-events: none;
	opacity: 0.9;
}
.content::before {
	width: 240px;
	height: 240px;
	left: -90px;
	top: 140px;
	background: radial-gradient(circle at 30% 30%, rgba(255, 184, 220, 0.55), transparent 60%),
		radial-gradient(circle at 70% 70%, rgba(110, 231, 255, 0.45), transparent 62%);
	border-radius: 999px;
}
.content::after {
	width: 280px;
	height: 280px;
	right: -140px;
	bottom: 90px;
	background: radial-gradient(circle at 40% 30%, rgba(196, 255, 214, 0.5), transparent 60%),
		radial-gradient(circle at 70% 70%, rgba(255, 224, 170, 0.45), transparent 62%);
	border-radius: 999px;
}
/* 不要对 `.content > *` 统一加 position/z-index，会破坏 Vant Dialog/Popup 的 fixed 布局 */

.content /deep/ .van-tabs__wrap {
	border: 1px solid var(--q-line);
	border-radius: 999px;
	background: rgba(255, 255, 255, 0.86);
	box-shadow: var(--q-shadow-sm);
	overflow: hidden;
}
.content /deep/ .van-tabs__line {
	background: linear-gradient(180deg, var(--q-primary) 0%, var(--q-primary-2) 100%);
}

.content /deep/ .van-button {
	border-radius: 999px;
	transition: transform 120ms ease, filter 120ms ease;
}
.content /deep/ .van-button:active {
	transform: translateY(1px) scale(0.985);
	filter: saturate(1.05);
}
.content /deep/ .van-button--primary {
	border: none;
	background: linear-gradient(180deg, var(--q-primary) 0%, var(--q-primary-2) 100%);
	box-shadow: 0 8px 18px rgba(52, 195, 255, 0.22);
}
.content /deep/ .van-button--danger {
	border: none;
	background: linear-gradient(180deg, #ff6b84 0%, var(--q-danger) 100%);
	box-shadow: 0 8px 18px rgba(255, 95, 122, 0.22);
}
.content /deep/ .van-button--plain.van-button--primary {
	border: 1px solid rgba(52, 195, 255, 0.55);
	background: rgba(255, 255, 255, 0.86);
	color: #0ea5e9;
	box-shadow: 0 6px 14px rgba(52, 195, 255, 0.12);
}

.current {
	margin-top: 16px;
	text-align: center;
	font-weight: bold;
	border: 2px solid transparent;
	border-radius: 999px;
	padding: 8px 12px;
	background: linear-gradient(var(--q-card), var(--q-card)) padding-box,
		linear-gradient(135deg, rgba(52, 195, 255, 0.45), rgba(255, 107, 132, 0.35), rgba(45, 212, 191, 0.35)) border-box;
	box-shadow: var(--q-shadow-sm);
	position: relative;
}

.current::after {
	content: "⚖️";
	position: absolute;
	right: 10px;
	top: 50%;
	transform: translateY(-50%) rotate(8deg);
	opacity: 0.85;
	pointer-events: none;
}

.input-weight {
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 24px;
	gap: 8px;
	padding: 10px 12px;
	border: 1px solid var(--q-line);
	border-radius: var(--q-radius);
	background: var(--q-card);
	box-shadow: var(--q-shadow-sm);
}

.input-weight button {
	width: 78px;
	height: 32px;
	margin-left: 16px;
}

.record-content {
	margin-top: 12px;
	overflow: auto;
	flex: 1;
	display: flex;
	flex-direction: column;
	border: 1px solid var(--q-line);
	border-radius: var(--q-radius);
	background: rgba(255, 255, 255, 0.86);
	box-shadow: var(--q-shadow-sm);
	padding: 10px;
	box-sizing: border-box;
}

.weight-content-record-box {
	font-size: 12px;
	overflow-y: auto;
}

.weight-content-record {
	display: flex;
	align-items: center;
	margin-bottom: 12px;
}

.weight-content-record-column {
	flex: 1;
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;
}

.weight-content-record-column>span {
	font-size: 10px;
	color: red;
	margin-left: 4px;
}

.weight-content-record-down {
	color: green !important;
}

#myChart {
	margin: -40px 0 -12px;
}
</style>
